// src/lib/utm.js
// UTM preservation: capture campaign params on landing, persist for the session,
// and expose them so forms can attach attribution to every lead submission.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORE_KEY = 'utm_params';

/**
 * Capture UTM params from the current URL (if any) into sessionStorage.
 * First-touch wins within a session: existing stored params are not overwritten
 * by a later param-less navigation. Safe to call on every app load.
 */
export function captureUtm() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
      const serialized = JSON.stringify(found);
      // Persist in BOTH: sessionStorage (this visit) + localStorage (survives
      // session end, so a returning visitor keeps first-touch attribution).
      sessionStorage.setItem(STORE_KEY, serialized);
      window.localStorage.setItem(STORE_KEY, serialized);
    }
  } catch {
    /* storage / URL unavailable — ignore */
  }
}

/** Return the stored UTM params object ({} if none) for attaching to forms. */
export function getUtmParams() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(STORE_KEY) || window.localStorage.getItem(STORE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
